import React, { useState } from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import { useLiveChatState } from "../Provider/LiveChatStateProvider";
import { toast } from "react-toastify";

interface LiveChatTerminateProps {
  onClose: () => void;
  onSuccess?: () => void;
}

const LiveChatTerminate = ({ onClose, onSuccess }: LiveChatTerminateProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<AppThunkDispatch>();
  const { currentScreen } = useLiveChatState();

  const handleTerminate = async () => {
    try {
      setIsLoading(true);
      const { authenticatedCall } = actionsHandler("terminateGroupChat");

      const id = currentScreen?.data.group?.room_id?.toString();

      if (!id) {
        toast.warning("Group ID not found");
        return;
      }

      const response = await dispatch(
        authenticatedCall({
          method: "post",
          payload: {},
          formattingParams: {
            id: id,
          },
        }),
      );

      if (response.ok) {
        toast.success(response.data.message || "Chat terminated successfully");
        onSuccess?.();
        onClose();
      } else {
        toast.error(response.data.message || "Failed to terminate chat");
      }
    } catch (error) {
      console.error("Error terminating chat:", error);
      toast.error("An error occurred while terminating the chat");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
        <div className="tw-bg-white tw-rounded-2xl tw-w-[400px] tw-p-6">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
            <div></div>
            <div>
              <h2 className="tw-text-[#232323] tw-text-base tw-font-semibold">
                Terminate Chat?
              </h2>
            </div>
            <div>
              <button onClick={onClose} disabled={isLoading}>
                <img
                  src={CloseIcon}
                  alt="close"
                  className="tw-h-4 tw-w-4 tw-min-w-4 tw-min-h-4"
                />
              </button>
            </div>
          </div>

          <div className="form-group tw-mb-6">
            <p className="tw-text-[#232323] font-weight-bold tw-text-base leading tw-mb-2">
              Are you sure you want to end the chat?
            </p>
            <p className="tw-text-[#232323] tw-text-sm tw-font-normal">
              Terminating the chat will disable further communication for all
              users in this group.
            </p>
          </div>

          <div className="tw-flex tw-space-x-4">
            <button
              onClick={onClose}
              className="tw-flex-1 tw-px-4 tw-py-2 tw-border tw-text-[#414651] tw-border-[#D5D7DA] tw-rounded-lg tw-w-[50%] tw-text-center"
              disabled={isLoading}
            >
              No
            </button>
            <button
              onClick={handleTerminate}
              disabled={isLoading}
              className={`tw-bg-[#146C94] tw-flex tw-items-center tw-gap-2 tw-w-[50%] 
              tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button
              ${isLoading ? "tw-opacity-70 tw-cursor-not-allowed" : ""}`}
            >
              {isLoading ? "Terminating..." : "Yes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveChatTerminate;
